module.exports = __webpack_public_path__ + "static/media/back button.fc5187f6.svg";